export enum roleTypeEnum {
  SUPERADMIN = 1,
  ADMIN = 2,
  EDUCATION=8
}
